import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import WeightClasses from "./WeightClasses";
import { fetchWeightRestriction } from "../../../redux/action/homeAction";

const WeightClassesRestrictions = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => state?.homeReducer
  );

  useEffect(() => {
    dispatch(fetchWeightRestriction());
  }, []);
  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Weight classes/restrictions"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Weight classes/restrictions", path: `${pageRoutes?.home}/` },
        ]}
      />
      <WeightClasses />
      <Footer />
    </div>
  );
};

export default WeightClassesRestrictions;
